import React from 'react';
import { useDispatch } from 'react-redux';
import { Box, Card, Typography, CardMedia, CardActionArea, CardContent } from '@mui/material';

import { Icon } from 'app/main/components';
import showTotemCommunicationsDialog from '../dialogs/TotemCommunicationsDialog';

interface TotemCommunicationItemProps {
	model: any;
}

const FadeOverlay = () => (
	<Box
		className="align-middle absolute bottom-0 left-0 h-64 w-full text-center"
		sx={theme => ({
			backgroundImage: `linear-gradient(to top, ${theme.palette.background.paper}, 75%, transparent)`
		})}
	/>
);

export default function TotemCommunicationItem(props: TotemCommunicationItemProps) {
	const dispatch = useDispatch();

	const thumbnailUrl = props.model.coms_image
		? `${import.meta.env.VITE_ENDPOINT}/resources/communications/thumbnails/${props.model.coms_image}?v=${Date.now()}`
		: undefined;

	function handleOpen() {
		dispatch(
			showTotemCommunicationsDialog({
				image: thumbnailUrl,
				uid: props.model.coms_uid,
				title: props.model.coms_title,
				text: props.model.coms_descriptionhtml
			})
		);
	}

	return (
		<Card className="relative h-full rounded-lg" variant="outlined">
			<CardActionArea className="h-full" onClick={handleOpen}>
				<CardMedia className="flex h-160 items-center justify-center" image={thumbnailUrl}>
					{!props.model.coms_image ? <Icon icon="comment-processing-outline" size={96} /> : <></>}
				</CardMedia>
				<CardContent>
					<Typography gutterBottom variant="subtitle2">
						{props.model.coms_title}
					</Typography>
					<Typography
						variant="body2"
						color="text.secondary"
						sx={{
							minHeight: '10vh',
							maxHeight: '10vh',
							overflow: 'hidden'
						}}
					>
						{props.model.coms_description}
					</Typography>
				</CardContent>
				<FadeOverlay />
			</CardActionArea>
		</Card>
	);
}
